import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "order-tickets",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        id: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    refund: function refund(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this2.$confirm("\u786E\u8BA4\u64CD\u4F5C", "会员退款", {
                confirmButtonText: "确定",
                confirmButtonClass: "el-button--danger",
                cancelButtonText: "取消",
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this2.$api.activityOrderRefund({
                        order_id: row.id
                      });
                    case 1:
                      _this2.$message.success("操作成功");
                      _this2.getData();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              }))).catch(function () {});
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              _this3.tableLoading = true;
              _context4.n = 1;
              return _this3.$api.getTicketOrderList(_this3.searchForm);
            case 1:
              res = _context4.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
              _this3.tableData = _this3.tableData.map(function (item) {
                var _item$user;
                return _objectSpread(_objectSpread({}, item), {}, {
                  userId: ((_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.id) || ''
                });
              });
              _this3.getUserListByIds(_this3.tableData, "userId");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};